import styled, { keyframes } from "styled-components";

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  input {
    padding: 10px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    min-width: 220px;
  }
  margin-right: 20px;
`;
export const Container = styled.div`
  width: 100%;
  padding: 24px 24px 48px;
  box-sizing: border-box;

  display: flex;
  justify-content: center;

  @media only screen and (max-width: 600px) {
    #search {
      width: 148px;
    }
  }
  table {
    padding: 10px;
  }
`;
export const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;
export const Title = styled.h2`
  margin: 0;
  color: #212121;
  font-size: 24px;
  line-height: 1.2;
`;
export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;
export const TableCard = styled.div`
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eeeeee;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  padding: 8px 8px 12px;
`;
export const ProductImage = styled.img`
  width: 88px;
  height: 88px;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid #eeeeee;

  @media only screen and (max-width: 600px) {
    width: 64px;
    height: 64px;
  }
`;
export const PriceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  color: #424242;
`;
export const PriceItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const PriceInput = styled.input`
  width: 60px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 13px;
  font-weight: 500;
  text-align: right;
  background: #fff;
  transition: border-color 160ms ease;

  &:focus {
    border-color: #1e88e5;
    outline: none;
  }
`;
export const PriceFeedback = styled.span`
  font-size: 11px;
  margin-left: 6px;
  color: ${(props) =>
    props.status === "error" ? "#d32f2f" : "#1e88e5"};
`;
const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
export const PriceSpinner = styled.div`
  width: 14px;
  height: 14px;
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-top-color: #ed4e2a;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  margin-left: 6px;
`;
export const PriceControlRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
export const PriceLabel = styled.span`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #757575;
`;
export const PriceValue = styled.span`
  font-size: 14px;
  font-weight: 600;
`;
export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: ${(props) => (props.active ? "#e7f6ec" : "#fbe9e7")};
  color: ${(props) => (props.active ? "#1b5e20" : "#bf360c")};
`;
export const CreateButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ed4e2a;
  color: #fff;
  padding: 10px 16px;
  border-radius: 10px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 6px 16px rgba(237, 78, 42, 0.3);
  transition: transform 160ms ease, box-shadow 160ms ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(237, 78, 42, 0.35);
  }
`;
export const InlineEditToggle = styled.button`
  border: 1px solid #ed4e2a;
  background: transparent;
  color: #ed4e2a;
  padding: 10px 16px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 160ms ease, color 160ms ease;

  &:hover {
    background: #ed4e2a;
    color: #fff;
  }
`;
